import {
  initializePdfFormStateObject,
  pdfFormReducerActions,
} from "../../submission/RequestSubmissionReducer";
import { statusColor } from "../../submission/upload/DocumentUpload";

export const init = (payload) => {
  const {
    pdfFormUrl,
    pdfFormName,
    fieldDefinitions,
    uploadConstraints,
    id,
    uid,
    title,
    href,
    info,
    submissionDate,
    subject,
    solver,
  } = payload;

  let pdfForm = initializePdfFormStateObject(pdfFormUrl, pdfFormName, fieldDefinitions, 1.5);

  return {
    id,
    uid,
    title,
    href,
    color: "grey",
    pdfForm,
    uploadConstraints,
    additionalDocs: [],
    info,
    submissionDate,
    subject,
    solver,
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "init":
      return init(action.payload);
    case "update-documents":
      state.additionalDocs.forEach((doc) => {
        doc.color = statusColor(doc.uploadStatus);
      });
      return { ...state };
    case "reset":
      state.pdfForm.validationErrors = {};
      state.pdfForm.currentFieldValues = { ...state.pdfForm.previous };
      return { ...state, pdfForm: { ...state.pdfForm } };
    case "save-previous-field-values":
      return {
        ...state,
        pdfForm: {
          ...state.pdfForm,
          previous: { ...state.pdfForm.currentFieldValues },
        },
      };
    default:
      return pdfFormReducerActions(state, action) || state;
  }
};
